import { Badge, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import React from "react";

type InGeniusSavingBadgeProps =
  | { variant: "absolute"; savingsAmount: string }
  | { variant: "percentage"; percentageDiscount: number };

/**
 * FLVE-2058: Genius Savings badge supporting V1 (absolute) and V2 (percentage)
 */
const InGeniusSavingBadge = (props: InGeniusSavingBadgeProps) => {
  const i18n = useI18n();

  const badgeText =
    props.variant === "percentage"
      ? i18n.trans(
          t("flights_genius_saving_badge_percentage_off", {
            variables: {
              percentage: `${props.percentageDiscount}%`
            }
          })
        )
      : i18n.trans(
          t("flights_fd_campaign_saving_amount_badge", {
            variables: {
              currency_price_saving: props.savingsAmount
            }
          })
        );

  return (
    <Stack direction="row">
      <Text>{i18n.trans(t("flights_fd_campaign_flight_price"))}</Text>
      <Badge variant="brand-genius-primary" text={badgeText} alternative />
    </Stack>
  );
};

export default InGeniusSavingBadge;
